import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { concatMap, tap, expand, toArray } from 'rxjs/operators';
import { FacebookPage } from '../components/setup/facebook-setup/facebook-page';

type FacebookResponse = {
  data: FacebookPage[],
  paging: {
    next: string,
    previous: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class FacebookService {

  constructor(
    private _http: HttpClient,
  ) { }

  private getPages(url: string): Observable<FacebookResponse> {
    return this._http.get<FacebookResponse>(url).pipe(
      tap(response => console.log(url, response))
    );
  }

  private getAllPages(url: string): Observable<FacebookPage[]> {
    return this.getPages(url).pipe(
      expand(response => response.paging.next ? this.getPages(response.paging.next) : EMPTY),
      concatMap(response => response.data),
      toArray()
    );
  }

  getAccounts(id: string, accessToken: string): Observable<FacebookPage[]> {
    return this.getAllPages(`https://graph.facebook.com/${id}/accounts?access_token=${accessToken}`);
  }
}
